import { createContext, useContext, useState, useCallback, useEffect, useMemo } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);
const LANGS = ["es", "en", "fr", "ru"];

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("frenchies_lang");
    return LANGS.includes(saved) ? saved : "es";
  });

  useEffect(() => {
    localStorage.setItem("frenchies_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) break;
      }
      if (node === undefined) {
        // fallback to spanish
        let f = translations.es;
        for (const p of parts) f = f?.[p];
        return f ?? path;
      }
      return node;
    },
    [lang]
  );

  // Resolve a {es,en,fr} localized object
  const tl = useCallback(
    (obj) => {
      if (!obj) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] || obj.es || obj.en || "";
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t, tl, langs: LANGS }), [lang, t, tl]);

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
